import React, { useState } from 'react'
import useDialogState from '@/hooks/use-dialog-state'
import { Client } from '../data/schema'

export type ClientsDialogType = 'add' | 'edit' | 'delete'

interface ClientsContextType {
  open: ClientsDialogType | null
  setOpen: (str: ClientsDialogType | null) => void
  currentRow: Client | null
  setCurrentRow: React.Dispatch<React.SetStateAction<Client | null>>
}

const ClientsContext = React.createContext<ClientsContextType | null>(null)

interface Props {
  children: React.ReactNode
}

export default function ClientsProvider({ children }: Props) {
  const [open, setOpen] = useDialogState<ClientsDialogType>(null)
  const [currentRow, setCurrentRow] = useState<Client | null>(null)

  return (
    <ClientsContext value={{ open, setOpen, currentRow, setCurrentRow }}>
      {children}
    </ClientsContext>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useClients = () => {
  const usersContext = React.useContext(ClientsContext)

  if (!usersContext) {
    throw new Error('useClients has to be used within <ClientsContext>')
  }

  return usersContext
}
